module.exports = __webpack_public_path__ + "static/media/_DSC6125.bc077cbf.jpg";